import { forwardRef, useId } from 'react';

const Input = forwardRef(function Input(
  { label, hint, error, className = '', id, ...rest },
  ref,
) {
  const generatedId = useId();
  const inputId = id ?? generatedId;
  return (
    <div className="space-y-1">
      {label ? (
        <label htmlFor={inputId} className="block text-xs font-semibold text-secondText">
          {label}
        </label>
      ) : null}
      <input
        ref={ref}
        id={inputId}
        className={[
          'w-full rounded-full border bg-surface px-4 py-2 text-sm text-text',
          'placeholder:text-secondText/70',
          error
            ? 'border-danger focus:border-danger focus:ring-2 focus:ring-danger/30'
            : 'border-border focus:border-primary focus:ring-2 focus:ring-primary/30',
          'focus:outline-none transition',
          className,
        ].join(' ')}
        {...rest}
      />
      {error ? (
        <p className="text-xs text-danger">{error}</p>
      ) : hint ? (
        <p className="text-xs text-secondText">{hint}</p>
      ) : null}
    </div>
  );
});

export default Input;

export const TextArea = forwardRef(function TextArea(
  { label, hint, error, className = '', id, rows = 4, ...rest },
  ref,
) {
  const generatedId = useId();
  const textAreaId = id ?? generatedId;
  return (
    <div className="space-y-1">
      {label ? (
        <label htmlFor={textAreaId} className="block text-xs font-semibold text-secondText">
          {label}
        </label>
      ) : null}
      <textarea
        ref={ref}
        id={textAreaId}
        rows={rows}
        className={[
          'w-full rounded-2xl border bg-surface px-4 py-3 text-sm text-text',
          'placeholder:text-secondText/70',
          error
            ? 'border-danger focus:border-danger focus:ring-2 focus:ring-danger/30'
            : 'border-border focus:border-primary focus:ring-2 focus:ring-primary/30',
          'focus:outline-none transition resize-y',
          className,
        ].join(' ')}
        {...rest}
      />
      {error ? (
        <p className="text-xs text-danger">{error}</p>
      ) : hint ? (
        <p className="text-xs text-secondText">{hint}</p>
      ) : null}
    </div>
  );
});
